var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('carousel',{ref:("carousel_" + (this.id)),class:this.class,attrs:{"id":this.id,"margin":10,"auto-width":_vm.attribute.autoWidth != null ? _vm.attribute.autoWidth : true,"nav":_vm.attribute.nav,"dots":_vm.attribute.dots,"items":1,"nav-text":['<', '>']},on:{"changed":_vm.carouselChanged,"updated":_vm.carouselUpdated}},[_vm._t("default")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bd79eae","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/uikit/components/IcAnsCarousel/IcAnsCarousel.vue
// module id = 527
// module chunks = 0